/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from 'react';
import { deprecatedMsg } from './deprecatedMsg.js';

export function isClassComponent(component: any) {
  console.warn(`isClassComponent ${deprecatedMsg}`);
  return !!(typeof component === 'function' && !!component.prototype.isReactComponent);
}

export function isFunctionComponent(component: any) {
  console.warn(`isFunctionComponent ${deprecatedMsg}`);
  return typeof component === 'function' && String(component).includes('return React.createElement');
}

export function isReactComponent(component: any) {
  console.warn(`isReactComponent ${deprecatedMsg}`);
  return !!(isClassComponent(component) || isFunctionComponent(component));
}

export function isElement(element: Record<string, unknown> | null | undefined) {
  console.warn(`isElement ${deprecatedMsg}`);
  return React.isValidElement(element);
}

export function isCompositeTypeElement(element: Record<string, unknown> | null | undefined) {
  console.warn(`isCompositeTypeElement ${deprecatedMsg}`);
  return isElement(element) && typeof element?.type === 'function';
}
